import { Lightbulb, Plus, Trash2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { STATUTS_ACTION } from '../qualiopi/constantes';
import { Champ } from './constantes';
import { AideSeance } from './AideSeance';

const Decisions = ({ decisions, i, onChange, onPlan, occupe }) => {
  const maj = (k, champ, v) => onChange(decisions.map((d, j) => (j === k ? { ...d, [champ]: v } : d)));
  return (
    <div className="mt-5" data-testid={`cp-decisions-${i}`}>
      <span className="block text-xs font-semibold uppercase tracking-wide text-slate-500">Décisions du conseil</span>
      <ul className="mt-2 space-y-2">
        {decisions.map((d, k) => (
          <li key={d.decision_id || `n${k}`} className="grid gap-2 rounded-xl bg-slate-50 p-3 xl:grid-cols-[1fr_150px_140px_170px_auto] xl:items-center" data-testid={`cp-decision-${i}-${k}`}>
            <Input value={d.texte} onChange={(e) => maj(k, 'texte', e.target.value)} placeholder="Décision prise" className="bg-white" data-testid={`cp-decision-texte-${i}-${k}`} />
            <Input value={d.responsable || ''} onChange={(e) => maj(k, 'responsable', e.target.value)} placeholder="Responsable" className="bg-white" data-testid={`cp-decision-responsable-${i}-${k}`} />
            <Input type="date" value={d.echeance || ''} onChange={(e) => maj(k, 'echeance', e.target.value)} className="bg-white" data-testid={`cp-decision-echeance-${i}-${k}`} />
            <Input value={d.preuve || ''} onChange={(e) => maj(k, 'preuve', e.target.value)} placeholder="Preuve / indicateur" className="bg-white" data-testid={`cp-decision-preuve-${i}-${k}`} />
            <div className="flex items-center gap-1">
              {d.action ? (
                <span className="whitespace-nowrap rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700" data-testid={`cp-decision-plan-ok-${i}-${k}`}>
                  {d.action.numero} · {STATUTS_ACTION[d.action.statut]?.label}
                </span>
              ) : (
                <Button size="sm" variant="outline" onClick={() => onPlan(k)} disabled={!!occupe || !d.texte.trim()} className="whitespace-nowrap bg-white" data-testid={`cp-decision-plan-${i}-${k}`}>
                  {occupe === `plan-${i}-${k}` ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Lightbulb className="mr-1.5 h-3.5 w-3.5" />} Plan d'amélioration
                </Button>
              )}
              <button type="button" onClick={() => onChange(decisions.filter((_, j) => j !== k))} title="Supprimer" data-testid={`cp-decision-supprimer-${i}-${k}`}
                className="rounded-lg p-2 text-slate-400 transition-colors hover:bg-red-50 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
            </div>
          </li>
        ))}
      </ul>
      <Button variant="ghost" size="sm" className="mt-2 text-[#6FA22E]" onClick={() => onChange([...decisions, { texte: '', responsable: '', echeance: '', preuve: '' }])} data-testid={`cp-decision-ajouter-${i}`}>
        <Plus className="mr-1.5 h-4 w-4" /> Ajouter une décision
      </Button>
    </div>
  );
};

export const PointCompteRendu = ({ p, i, aide, onChange, onPlan, occupe }) => {
  const set = (champ) => (e) => onChange({ ...p, [champ]: e.target.value });
  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm" data-testid={`cp-cr-point-${i}`}>
      <h3 className="flex items-start gap-3 text-base md:text-lg font-semibold text-[#0F172A]">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#0F172A] text-xs font-bold text-white">{i + 1}</span>{p.titre}
      </h3>
      <AideSeance aide={aide} i={i} p={p} onChange={onChange} />
      <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        <Champ label="Ce qui a été présenté"><Textarea rows={4} value={p.presente} onChange={set('presente')} data-testid={`cp-cr-presente-${i}`} /></Champ>
        <Champ label="Propositions des membres"><Textarea rows={4} value={p.propositions} onChange={set('propositions')} data-testid={`cp-cr-propositions-${i}`} /></Champ>
        <Champ label="Questions, avis et désaccords" className="md:col-span-2 xl:col-span-1">
          <Textarea rows={4} value={p.avis} onChange={set('avis')} data-testid={`cp-cr-avis-${i}`} />
        </Champ>
      </div>
      <Decisions decisions={p.decisions} i={i} onChange={(decisions) => onChange({ ...p, decisions })} onPlan={onPlan} occupe={occupe} />
    </article>
  );
};
